export default __webpack_public_path__ + "static/media/cache-icon.0a3d7b96.png";